import React from 'react';
import { 
    Create, 
    SimpleForm, 
    TextInput,
    ReferenceInput,
    SelectInput,
    required 
} from 'react-admin';
import { FormToolbar } from "../../common/FormToolbar";

export const SectionCreate = props => {
    return (
        <React.Fragment>
            <Create label="Create Section" {...props}>
                <SimpleForm toolbar={<FormToolbar {...props} />}>
                    <ReferenceInput 
                        source="class_id" 
                        reference="genere" 
                        label="Class"
                        fullWidth
                    >
                        <SelectInput optionText="class_name" validate={[required()]} fullWidth={true} />
                    </ReferenceInput>
                    
                    <TextInput 
                        source="section" 
                        label='Section Name' 
                        fullWidth={true}
                        validate={[required()]} 
                        helperText="E.g., A, B, C, etc."
                    />
                </SimpleForm>
            </Create>
        </React.Fragment>
    );
}
